(function () {
  function variantId() {
    return window.PirateDesign ? window.PirateDesign.variant() : null;
  }

  function designId() {
    return window.PirateDesign ? window.PirateDesign.id() : null;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function isPrintLine(item) {
    return item.properties && item.properties._design_id;
  }

  function shirtTotal(cart) {
    return cart.items.reduce(function (sum, item) {
      return isPrintLine(item) ? sum : sum + item.quantity;
    }, 0);
  }

  function printLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (isPrintLine(cart.items[i])) return cart.items[i];
    }
    return null;
  }

  function syncCart() {
    return getCart().then(function (cart) {
      var line = printLine(cart);
      if (!line) { showMismatch(false); return cart; }

      var shirts = shirtTotal(cart);
      if (line.quantity === shirts) { showMismatch(false); return cart; }

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: shirts })
      }).then(function (r) { return r.json(); }).then(function (updated) {
        var after = printLine(updated);
        showMismatch(!!after && after.quantity !== shirtTotal(updated));
        return updated;
      });
    });
  }

  function addPrintFor(quantity) {
    var vId = variantId();
    var dId = designId();
    if (!vId || !dId) return Promise.resolve(null);

    return getCart().then(function (cart) {
      var existing = printLine(cart);
      var shirts = shirtTotal(cart);

      if (existing) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: existing.key, quantity: shirts })
        }).then(function (r) { return r.json(); });
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: String(vId),
            quantity: shirts || quantity || 1,
            properties: {
              '_design_id': dId,
              'Design': 'Custom — view at ' + window.PirateDesign.recoveryUrl()
            }
          }]
        })
      }).then(function (r) { return r.json(); });
    });
  }

  function showMismatch(on) {
    var existing = document.getElementById('pirate-mismatch');

    if (!on) {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;

    var anchor = document.querySelector('cart-items, #main-cart-items, cart-drawer-items');
    if (!anchor) return;

    var box = document.createElement('div');
    box.id = 'pirate-mismatch';
    box.style.cssText = 'background:#fdeeee;border:1px solid #e24b4a;border-radius:8px;padding:12px 16px;margin:12px 0;font-size:14px;color:#a32d2d;display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;';
    box.innerHTML =
      '<span>Your print quantity doesn\'t match your shirt quantity. Each shirt needs its own print.</span>' +
      '<button type="button" id="pirate-fix" style="background:#e24b4a;color:#fff;border:none;border-radius:6px;padding:8px 16px;font-size:13px;cursor:pointer;white-space:nowrap;">Fix it</button>';

    anchor.parentNode.insertBefore(box, anchor);

    document.getElementById('pirate-fix').addEventListener('click', function () {
      syncCart().then(function () { window.location.reload(); });
    });
  }

  // Print line only: read-only quantity, no stepper, no delete
  function lockPrintQuantity(cart) {
    if (!designId()) return;

    var line = printLine(cart);
    if (!line) return;

    var rows = document.querySelectorAll('.cart-item, tr.cart-item');
    rows.forEach(function (row) {
      var text = row.textContent || '';
      if (text.indexOf('Design') === -1 && text.indexOf('Print') === -1) return;
      if (row.dataset.pirateLocked) return;
      row.dataset.pirateLocked = '1';

      var qtyWrap = row.querySelector('quantity-input, .quantity, .cart-item__quantity-wrapper');
      if (!qtyWrap) return;

      var note = document.createElement('div');
      note.style.cssText = 'font-size:13px;color:#666;line-height:1.6;';
      note.innerHTML = 'Qty: <strong>' + line.quantity + '</strong><br>' +
        '<span style="font-size:12px;">Matches your shirts</span>';

      qtyWrap.parentNode.replaceChild(note, qtyWrap);

      var removeBtn = row.querySelector('cart-remove-button, .cart-remove-button, [id^="Remove"]');
      if (removeBtn) removeBtn.style.display = 'none';
    });
  }

  function applyCartChanges() {
    return getCart().then(function (cart) {
      lockPrintQuantity(cart);
      return cart;
    });
  }

  function handleAdd(qty) {
    setTimeout(function () {
      addPrintFor(qty).then(function () {
        document.dispatchEvent(new CustomEvent('pirate:print-added'));
        if (window.location.pathname.indexOf('/cart') === 0) window.location.reload();
      });
    }, 600);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    if (!designId()) return;

    var qtyInput = form.querySelector('[name="quantity"]');
    handleAdd(qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1);
  }, true);

  function hookProductForms() {
    document.querySelectorAll('product-form').forEach(function (pf) {
      if (pf.dataset.pirateHooked) return;
      pf.dataset.pirateHooked = '1';

      var btn = pf.querySelector('[name="add"], button[type="submit"]');
      if (!btn) return;

      btn.addEventListener('click', function () {
        if (!designId()) return;
        var qtyInput = pf.querySelector('[name="quantity"]');
        handleAdd(qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1);
      });
    });
  }

  document.addEventListener('cart:updated', function () {
    syncCart().then(applyCartChanges);
  });
  document.addEventListener('pirate:print-added', function () {
    syncCart().then(applyCartChanges);
  });

  function watchCart() {
    var cartRoot = document.querySelector('cart-items, cart-drawer, #main-cart-items');
    if (!cartRoot || !window.MutationObserver) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        syncCart().then(applyCartChanges);
      }, 400);
    }).observe(cartRoot, { childList: true, subtree: true });
  }

  // Checkout guard — sync, verify, then proceed
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[name="checkout"], .cart__checkout-button');
    if (!btn) return;
    if (!designId()) return;

    e.preventDefault();
    e.stopPropagation();

    var originalText = btn.textContent;
    btn.setAttribute('disabled', 'disabled');
    btn.textContent = 'Checking your order...';

    syncCart().then(function (cart) {
      var line = printLine(cart);
      var shirts = shirtTotal(cart);

      if (shirts === 0) {
        btn.removeAttribute('disabled');
        btn.textContent = originalText;
        showMismatch(false);
        window.location.reload();
        return;
      }

      if (line && line.quantity !== shirts) {
        btn.removeAttribute('disabled');
        btn.textContent = originalText;
        showMismatch(true);
        return;
      }

      window.location.href = '/checkout';
    }).catch(function () {
      btn.removeAttribute('disabled');
      btn.textContent = originalText;
      window.location.href = '/checkout';
    });
  }, true);

  function init() {
    hookProductForms();
    watchCart();
    syncCart().then(applyCartChanges);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();